
export const Redirect = ({ element }) => {
    const token = localStorage.getItem("token");
    window.location = "/"
    if (token) {  }
    else{
        return element;
    }
    
}